// Home's stroke icons — the exact paths Home.dc.html and the kit parts it imports draw
// inline (24-unit grid). Kept next to the screen (CB-D3): the shell's icon.tsx holds the
// frame's icons only.
const PATHS = {
  plus: 'M12 5v14M5 12h14',
  pin: 'M12 21s7-6.4 7-11a7 7 0 1 0-14 0c0 4.6 7 11 7 11',
  clock: 'M12 7.5V12l3 2',
  copy: 'M9 9h9.5A1.5 1.5 0 0 1 20 10.5V20a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 20v-9.5A1.5 1.5 0 0 1 9 9M5 15H4.5A1.5 1.5 0 0 1 3 13.5V4a1.5 1.5 0 0 1 1.5-1.5H14A1.5 1.5 0 0 1 15.5 4v.5',
  arrow: 'M5 12h13M12.5 6l6 6-6 6',
  phone:
    'M6.5 3.5h2l1.5 4-2 1.4a11 11 0 0 0 5.1 5.1l1.4-2 4 1.5v2A2.5 2.5 0 0 1 16 18a13 13 0 0 1-12-12 2.5 2.5 0 0 1 2.5-2.5',
  chevron: 'm9 5 7 7-7 7',
  // bd-core.js ICON.warn / ICON.star — the attention rows' tile icons.
  warn: 'M12 4.5 21 19.5H3zM12 10v4M12 17h.01',
  star: 'm12 4.5 2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.5-4.8 2.5.9-5.4L4.2 10.2l5.4-.8z',
} as const;

export type HomeIconName = keyof typeof PATHS;

// `pin` and `clock` carry the circle the design draws beside the path.
const CIRCLE: Partial<Record<HomeIconName, { cx: number; cy: number; r: number }>> = {
  pin: { cx: 12, cy: 10, r: 2.6 },
  clock: { cx: 12, cy: 12, r: 9 },
};

export function HomeIcon({
  name,
  size = 16,
  className,
  motion = false,
}: {
  name: HomeIconName;
  size?: number;
  className?: string;
  /** The icon animates (the "when" tile's tick) — reduced motion collapses it. */
  motion?: boolean;
}) {
  const circle = CIRCLE[name];
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-motion={motion ? '' : undefined}
    >
      {circle && name === 'clock' && <circle {...circle} />}
      <path d={PATHS[name]} />
      {circle && name !== 'clock' && <circle {...circle} />}
    </svg>
  );
}
